import {
  useMutation,
  useQuery,
  useQueryClient,
  UseMutateFunction,
  QueryObserverResult,
} from 'react-query';
import { setPageId, getSelectedPageId } from '~/api/routes/auth/user';

type SetPageMutation = UseMutateFunction<string, unknown, string, { previousId: string }>;

export function usePageQuery(): [string | undefined | null, SetPageMutation, QueryObserverResult<string | null>] {
  const queryClient = useQueryClient();

  const pageQuery = useQuery('page_id', getSelectedPageId);
  const { mutate } = useMutation(setPageId, {
    onMutate: async id => {
      await queryClient.cancelQueries('page_id');

      const previousId = queryClient.getQueryData('page_id');

      queryClient.setQueryData('page_id', id);

      return { previousId };
    },
    onError: (_data, _error, context: { previousId: string | null }) => {
      queryClient.setQueryData('page_id', context.previousId);
    },
    onSettled: () => {
      queryClient.invalidateQueries('page_id');
    },
  });

  const { data } = pageQuery;

  return [data, mutate, pageQuery];
}
